// extracted by mini-css-extract-plugin
export var LegalPageLayout = "LegalPageLayout-module--LegalPageLayout--hg6+M";
export var LegalPageLayout_header = "LegalPageLayout-module--LegalPageLayout_header--pxiqW";
export var LegalPageLayout_header_date = "LegalPageLayout-module--LegalPageLayout_header_date---1xNa";
export var LegalPageLayout_header_title = "LegalPageLayout-module--LegalPageLayout_header_title--t9gPP";
export var LegalPageLayout_main_desc = "LegalPageLayout-module--LegalPageLayout_main_desc--yFlDc";
export var container = "LegalPageLayout-module--container--E3G+x";
export var gatsbyImageWrapperConstrained = "LegalPageLayout-module--gatsby-image-wrapper-constrained--KzdfS";
export var gridSpan1010 = "LegalPageLayout-module--grid-span-10-10--8yOdO";
export var gridSpan1011 = "LegalPageLayout-module--grid-span-10-11--q-wW7";
export var gridSpan102 = "LegalPageLayout-module--grid-span-10-2--lQ6MH";
export var gridSpan103 = "LegalPageLayout-module--grid-span-10-3--4Opzs";
export var gridSpan104 = "LegalPageLayout-module--grid-span-10-4--9J7+X";
export var gridSpan105 = "LegalPageLayout-module--grid-span-10-5--+0hh2";
export var gridSpan106 = "LegalPageLayout-module--grid-span-10-6--rbMwe";
export var gridSpan107 = "LegalPageLayout-module--grid-span-10-7--G9+Lg";
export var gridSpan108 = "LegalPageLayout-module--grid-span-10-8--u9vJz";
export var gridSpan109 = "LegalPageLayout-module--grid-span-10-9--zxHK2";
export var gridSpan110 = "LegalPageLayout-module--grid-span-1-10---hjpN";
export var gridSpan111 = "LegalPageLayout-module--grid-span-1-11--dRHw-";
export var gridSpan1110 = "LegalPageLayout-module--grid-span-11-10--9736u";
export var gridSpan1111 = "LegalPageLayout-module--grid-span-11-11--3W9-y";
export var gridSpan112 = "LegalPageLayout-module--grid-span-11-2--eokNi";
export var gridSpan113 = "LegalPageLayout-module--grid-span-11-3--9l+jz";
export var gridSpan114 = "LegalPageLayout-module--grid-span-11-4--+H9kf";
export var gridSpan115 = "LegalPageLayout-module--grid-span-11-5--PV9ts";
export var gridSpan116 = "LegalPageLayout-module--grid-span-11-6--AJNkb";
export var gridSpan117 = "LegalPageLayout-module--grid-span-11-7--KNR4s";
export var gridSpan118 = "LegalPageLayout-module--grid-span-11-8--wJRG0";
export var gridSpan119 = "LegalPageLayout-module--grid-span-11-9--cXwYa";
export var gridSpan12 = "LegalPageLayout-module--grid-span-1-2--IysSk";
export var gridSpan1210 = "LegalPageLayout-module--grid-span-12-10--w0-V0";
export var gridSpan1211 = "LegalPageLayout-module--grid-span-12-11--C25Yw";
export var gridSpan122 = "LegalPageLayout-module--grid-span-12-2--exknt";
export var gridSpan123 = "LegalPageLayout-module--grid-span-12-3--6LFEU";
export var gridSpan124 = "LegalPageLayout-module--grid-span-12-4--bsgtf";
export var gridSpan125 = "LegalPageLayout-module--grid-span-12-5--W9vMT";
export var gridSpan126 = "LegalPageLayout-module--grid-span-12-6--DOjag";
export var gridSpan127 = "LegalPageLayout-module--grid-span-12-7--t3-7o";
export var gridSpan128 = "LegalPageLayout-module--grid-span-12-8--6lvNQ";
export var gridSpan129 = "LegalPageLayout-module--grid-span-12-9--2E-m1";
export var gridSpan13 = "LegalPageLayout-module--grid-span-1-3--soXvM";
export var gridSpan14 = "LegalPageLayout-module--grid-span-1-4--NRx5o";
export var gridSpan15 = "LegalPageLayout-module--grid-span-1-5--9B2-7";
export var gridSpan16 = "LegalPageLayout-module--grid-span-1-6--cLZbw";
export var gridSpan17 = "LegalPageLayout-module--grid-span-1-7--FGaR6";
export var gridSpan18 = "LegalPageLayout-module--grid-span-1-8--k-XJo";
export var gridSpan19 = "LegalPageLayout-module--grid-span-1-9--FR9tv";
export var gridSpan210 = "LegalPageLayout-module--grid-span-2-10--5wJZD";
export var gridSpan211 = "LegalPageLayout-module--grid-span-2-11--AA-rX";
export var gridSpan22 = "LegalPageLayout-module--grid-span-2-2--FB9kC";
export var gridSpan23 = "LegalPageLayout-module--grid-span-2-3--rcQMQ";
export var gridSpan24 = "LegalPageLayout-module--grid-span-2-4--4qyPI";
export var gridSpan25 = "LegalPageLayout-module--grid-span-2-5--kdIdy";
export var gridSpan26 = "LegalPageLayout-module--grid-span-2-6--Tpwmq";
export var gridSpan27 = "LegalPageLayout-module--grid-span-2-7--G8pye";
export var gridSpan28 = "LegalPageLayout-module--grid-span-2-8--0gi7I";
export var gridSpan29 = "LegalPageLayout-module--grid-span-2-9--6amdC";
export var gridSpan310 = "LegalPageLayout-module--grid-span-3-10--1WSH-";
export var gridSpan311 = "LegalPageLayout-module--grid-span-3-11--S20Zw";
export var gridSpan32 = "LegalPageLayout-module--grid-span-3-2--jGBDI";
export var gridSpan33 = "LegalPageLayout-module--grid-span-3-3--9R+is";
export var gridSpan34 = "LegalPageLayout-module--grid-span-3-4--hKbJv";
export var gridSpan35 = "LegalPageLayout-module--grid-span-3-5--zdqnl";
export var gridSpan36 = "LegalPageLayout-module--grid-span-3-6--J-fi0";
export var gridSpan37 = "LegalPageLayout-module--grid-span-3-7--TsuTO";
export var gridSpan38 = "LegalPageLayout-module--grid-span-3-8--vsB5D";
export var gridSpan39 = "LegalPageLayout-module--grid-span-3-9--f5sNU";
export var gridSpan410 = "LegalPageLayout-module--grid-span-4-10--kfLNT";
export var gridSpan411 = "LegalPageLayout-module--grid-span-4-11--H0Kas";
export var gridSpan42 = "LegalPageLayout-module--grid-span-4-2--s1A5B";
export var gridSpan43 = "LegalPageLayout-module--grid-span-4-3--b-Lx-";
export var gridSpan44 = "LegalPageLayout-module--grid-span-4-4--mt8c2";
export var gridSpan45 = "LegalPageLayout-module--grid-span-4-5--6sTqh";
export var gridSpan46 = "LegalPageLayout-module--grid-span-4-6--rPnRt";
export var gridSpan47 = "LegalPageLayout-module--grid-span-4-7--xpTk7";
export var gridSpan48 = "LegalPageLayout-module--grid-span-4-8--wY5L5";
export var gridSpan49 = "LegalPageLayout-module--grid-span-4-9--9GsnU";
export var gridSpan510 = "LegalPageLayout-module--grid-span-5-10--8uv5+";
export var gridSpan511 = "LegalPageLayout-module--grid-span-5-11--eGYbY";
export var gridSpan52 = "LegalPageLayout-module--grid-span-5-2--1f4vi";
export var gridSpan53 = "LegalPageLayout-module--grid-span-5-3--nAKsF";
export var gridSpan54 = "LegalPageLayout-module--grid-span-5-4--H10b6";
export var gridSpan55 = "LegalPageLayout-module--grid-span-5-5--fcHPq";
export var gridSpan56 = "LegalPageLayout-module--grid-span-5-6--1i7Fc";
export var gridSpan57 = "LegalPageLayout-module--grid-span-5-7--MzBVJ";
export var gridSpan58 = "LegalPageLayout-module--grid-span-5-8--e-2M9";
export var gridSpan59 = "LegalPageLayout-module--grid-span-5-9--GIg2l";
export var gridSpan610 = "LegalPageLayout-module--grid-span-6-10--VNUTl";
export var gridSpan611 = "LegalPageLayout-module--grid-span-6-11--57Ld9";
export var gridSpan62 = "LegalPageLayout-module--grid-span-6-2--7y1C7";
export var gridSpan63 = "LegalPageLayout-module--grid-span-6-3--0RBYL";
export var gridSpan64 = "LegalPageLayout-module--grid-span-6-4--CkQk0";
export var gridSpan65 = "LegalPageLayout-module--grid-span-6-5--VU9cV";
export var gridSpan66 = "LegalPageLayout-module--grid-span-6-6--dctb5";
export var gridSpan67 = "LegalPageLayout-module--grid-span-6-7--BCMqs";
export var gridSpan68 = "LegalPageLayout-module--grid-span-6-8--tDCeE";
export var gridSpan69 = "LegalPageLayout-module--grid-span-6-9--KIEo4";
export var gridSpan710 = "LegalPageLayout-module--grid-span-7-10--YXDmD";
export var gridSpan711 = "LegalPageLayout-module--grid-span-7-11--vZlq-";
export var gridSpan72 = "LegalPageLayout-module--grid-span-7-2--WNJoJ";
export var gridSpan73 = "LegalPageLayout-module--grid-span-7-3--Uj8F+";
export var gridSpan74 = "LegalPageLayout-module--grid-span-7-4--y7bDb";
export var gridSpan75 = "LegalPageLayout-module--grid-span-7-5--CmqP1";
export var gridSpan76 = "LegalPageLayout-module--grid-span-7-6--UPfMY";
export var gridSpan77 = "LegalPageLayout-module--grid-span-7-7--Ha-VZ";
export var gridSpan78 = "LegalPageLayout-module--grid-span-7-8---Ak0G";
export var gridSpan79 = "LegalPageLayout-module--grid-span-7-9--YpFob";
export var gridSpan810 = "LegalPageLayout-module--grid-span-8-10--cGeag";
export var gridSpan811 = "LegalPageLayout-module--grid-span-8-11--ujssQ";
export var gridSpan82 = "LegalPageLayout-module--grid-span-8-2--QwfHK";
export var gridSpan83 = "LegalPageLayout-module--grid-span-8-3--cJ4TU";
export var gridSpan84 = "LegalPageLayout-module--grid-span-8-4---HrgI";
export var gridSpan85 = "LegalPageLayout-module--grid-span-8-5--A4kyw";
export var gridSpan86 = "LegalPageLayout-module--grid-span-8-6--tnFYH";
export var gridSpan87 = "LegalPageLayout-module--grid-span-8-7--gxDkN";
export var gridSpan88 = "LegalPageLayout-module--grid-span-8-8--EZN+d";
export var gridSpan89 = "LegalPageLayout-module--grid-span-8-9--GWqnh";
export var gridSpan910 = "LegalPageLayout-module--grid-span-9-10--yMPxQ";
export var gridSpan911 = "LegalPageLayout-module--grid-span-9-11--g6vQo";
export var gridSpan92 = "LegalPageLayout-module--grid-span-9-2--rGAxK";
export var gridSpan93 = "LegalPageLayout-module--grid-span-9-3--J62UA";
export var gridSpan94 = "LegalPageLayout-module--grid-span-9-4--mLSRI";
export var gridSpan95 = "LegalPageLayout-module--grid-span-9-5--kLMJn";
export var gridSpan96 = "LegalPageLayout-module--grid-span-9-6--30wPy";
export var gridSpan97 = "LegalPageLayout-module--grid-span-9-7--DmCCv";
export var gridSpan98 = "LegalPageLayout-module--grid-span-9-8--FqPRV";
export var gridSpan99 = "LegalPageLayout-module--grid-span-9-9--v78Fo";
export var textBreak = "LegalPageLayout-module--text-break--tJbLN";